import React, { ReactNode } from 'react';

/**
 * A component that will only render its children when the `when` prop is true. This is helpful for maintaining the
 * scroll position.
 */
export function Visible({ when, children }: { when: boolean; children: ReactNode }) {
  return <span style={{ display: when ? undefined : 'none' }}>{children}</span>;
}
